import React from "react"

/*
Usage
<Cta />
*/

export default function CTA() {
    return (
              <div className="bg-white ">
                      <div className=" flex flex-col flex-grow bg-[#3333e6] rounded-lg text-center sm:py-8 sm:px-6 lg:px-8">
                          <h2 className="mt-0 text-1xl font-extrabold text-white sm:text-2xl">
                          <span className="block">Plomberie sanitaire ou chauffage</span>
                          </h2>
                          <p className="mt-4 text-m leading-6 text-blue-200">
                          Trouvez facilement un plombier de confiance. Réactivité, qualité et efficacité garanties.
                          </p>
                          <a
                          href="/devis/contact/"
                          className="no-underline inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 sm:w-auto"
                          >
                          Demandez un dépannage
                          </a>
                      </div>
              </div>
          )
}